/* unplugin-vue-components disabled */import { render } from "./icon-button.vue?vue&type=template&id=62454e06"
import script from "./icon-button.vue?vue&type=script&lang=js"
export * from "./icon-button.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/controls/icon-button.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "62454e06"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('62454e06', __exports__)) {
    api.reload('62454e06', __exports__)
  }
  
  module.hot.accept("./icon-button.vue?vue&type=template&id=62454e06", () => {
    api.rerender('62454e06', render)
  })

}


export default __exports__